(() => {
  const node = document.getElementById('mtl-photo-repairs');
  if (!node) return;
  const replacements = JSON.parse(node.textContent);
  function corrected(value) {
    if (!value) return null;
    try {
      const path = new URL(value, location.href).pathname;
      return replacements[decodeURIComponent(path.split('/').pop())] || null;
    } catch { return null; }
  }
  function repair(element) {
    if (!(element instanceof Element)) return;
    const elements = [element, ...element.querySelectorAll('img,[data-image]')];
    for (const el of elements) {
      if (el.matches('img')) {
        const url = corrected(el.getAttribute('src'));
        if (url) {
          el.removeAttribute('srcset');
          el.removeAttribute('sizes');
          el.src = url;
        }
      }
      const galleryUrl = corrected(el.getAttribute('data-image'));
      if (galleryUrl) el.setAttribute('data-image', galleryUrl);
    }
  }
  repair(document.documentElement);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') repair(record.target);
      else record.addedNodes.forEach(repair);
    }
  }).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['src', 'data-image']
  });
})();
